<template>
  <div class="auth-process-container">
    <div class="auth-process">
      <q-card bordered flat class="auth-process-card">
        <div class="auth-title">Reset Password</div>
        <q-form @submit="onSubmit" class="q-gutter-y-md">
          <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
            <span class="label-input mb-5">Email *</span>
            <q-input
              outlined
              hide-bottom-space
              color="grey-7"
              v-model="email"
              lazy-rules
              ref="email"
              placeholder="Type your email"
              :rules="[isValidEmail]"
            >
              <template v-slot:prepend>
                <q-icon size="16px" color="grey-7" name="fas fa-envelope"></q-icon>
              </template>
            </q-input>
          </div>
          <div class="flex-center">
            <q-btn id="forgot-password-btn" color="positive" type="submit" :loading="loading" label="Send Reset">
              <template v-slot:loading>
                <q-spinner-facebook />
              </template>
            </q-btn>
          </div>
          <div id="forgot-password-redirect" class="flex-center-item" @click="$router.push({ name: 'login' })">
            Return to Home
          </div>
        </q-form>
      </q-card>
    </div>
  </div>
</template>

<script>
import isValidEmail from '../helper/emailValidation'
import axios from '../axios/index'
export default {
  metaInfo() {
    return {
      title: 'Forgot Password | FMS',
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: ''
        },
        {
          property: 'og:title',
          content: 'Forgot Password | FMS'
        },
        { property: 'og:site_name', content: 'FMS' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  name: 'forgotPassword',
  data() {
    return {
      loading: false,
      email: ''
    }
  },
  methods: {
    isValidEmail,
    async onSubmit() {
      try {
        this.loading = true
        const { data } = await axios.post('auth/password', {
          email: this.email
        })
        this.$q.notify({
          message: 'Password reset sent. Please check inbox.',
          timeout: 2000,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 1500)
      } catch (error) {
        const message = error.response.data.message
        this.$q.notify({
          message,
          timeout: 1000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
        this.email = ''
        this.$refs.email.resetValidation()
      }
    }
  },
  mounted() {
    const emailRef = this.$refs.email
    const inputprofileRef = emailRef.$refs.input
    inputprofileRef.id = 'forgot-password-email'
  }
}
</script>
